<form [formGroup]="permissionsForm" (ngSubmit)="onSubmit()">
    <div class="bg-white w-full gap-4 p-4 grid grid-cols-2">
        <div class="flex flex-col gap-2">
         
             <mat-label>{{ 'roleName' | translate }}<span class="red">*</span></mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="role_name" />
             <mat-error *ngIf="permissionsForm.get('role_name')?.hasError('required')">
               {{ 'requiredRoleName' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div class="flex flex-col gap-2">
         
             <mat-label>{{ 'description' | translate }}<span class="red">*</span></mat-label>

          <mat-form-field appearance="outline">
            <input matInput formControlName="description" />
              <mat-error *ngIf="permissionsForm.get('description')?.hasError('required')">
              {{ 'requiredDescription' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
    </div>

    <div class="bg-white w-full gap-4 p-4 grid grid-cols-1">


        <div class="mb-4 flex justify-between items-center">
            <h3 class="text-lg font-semibold">Permissions</h3>
            <button 
                type="button"
                (click)="toggleAll()"
                class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors">
                <span *ngIf="!allChecked">Check All</span>
                <span *ngIf="allChecked">Uncheck All</span>
            </button>
        </div>

        <table class="w-full border-collapse border border-gray-300">
            <thead>
                <tr class="bg-gray-100">
                    <th class="border border-gray-300 px-4 py-2 text-left">{{ 'module' | translate }}</th>
                    <th class="border border-gray-300 px-4 py-2 text-center">
                        <div class="flex flex-col items-center gap-1">
                            <span class="text-sm font-medium">{{ 'add' | translate }}</span>
                            <mat-checkbox 
                                [checked]="isAllCheckedForAction('add')"
                                (change)="toggleActionAll('add')"
                                [indeterminate]="false"
                                title="Check/Uncheck all Add permissions">
                            </mat-checkbox>
                        </div>
                    </th>
                    <th class="border border-gray-300 px-4 py-2 text-center">
                        <div class="flex flex-col items-center gap-1">
                            <span class="text-sm font-medium">{{ 'view' | translate }}</span>
                            <mat-checkbox 
                                [checked]="isAllCheckedForAction('view')"
                                (change)="toggleActionAll('view')"
                                [indeterminate]="false"
                                title="Check/Uncheck all View permissions">
                            </mat-checkbox>
                        </div>
                    </th>
                    <th class="border border-gray-300 px-4 py-2 text-center">
                        <div class="flex flex-col items-center gap-1">
                            <span class="text-sm font-medium">{{ 'update' | translate }}</span>
                            <mat-checkbox 
                                [checked]="isAllCheckedForAction('update')"
                                (change)="toggleActionAll('update')"
                                [indeterminate]="false"
                                title="Check/Uncheck all Update permissions">
                            </mat-checkbox>
                        </div>
                    </th>
                    <th class="border border-gray-300 px-4 py-2 text-center">
                        <div class="flex flex-col items-center gap-1">
                            <span class="text-sm font-medium">{{ 'delete' | translate }}</span>
                            <mat-checkbox 
                                [checked]="isAllCheckedForAction('delete')"
                                (change)="toggleActionAll('delete')"
                                [indeterminate]="false"
                                title="Check/Uncheck all Delete permissions">
                            </mat-checkbox>
                        </div>
                    </th>
                </tr>
            </thead>
            <tbody formArrayName="permissions">
                <tr *ngFor="let group of permissionsArray.controls; let i = index" 
                    [formGroupName]="i"
                    class="hover:bg-gray-50">
                    <td class="border border-gray-300 px-4 py-2 font-medium">
                        {{ group.value.module | titlecase }}
                    </td>
                    <td class="border border-gray-300 px-4 py-2 text-center">
                        <mat-checkbox 
                            formControlName="add"
                            (change)="updateAllCheckedStatus()">
                        </mat-checkbox>
                    </td>
                    <td class="border border-gray-300 px-4 py-2 text-center">
                        <mat-checkbox 
                            formControlName="view"
                            (change)="updateAllCheckedStatus()">
                        </mat-checkbox>
                    </td>
                    <td class="border border-gray-300 px-4 py-2 text-center">
                        <mat-checkbox 
                            formControlName="update"
                            (change)="updateAllCheckedStatus()">
                        </mat-checkbox>
                    </td>
                    <td class="border border-gray-300 px-4 py-2 text-center">
                        <mat-checkbox 
                            formControlName="delete"
                            (change)="updateAllCheckedStatus()">
                        </mat-checkbox>
                    </td>
                </tr>
            </tbody>
        </table>
        <br />
        <div class="flex justify-center mt-6">
            <button type="submit"
                class="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-md font-medium shadow-sm transition">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
                {{ 'submit' | translate }}
            </button>
        </div>

    </div>



</form>